import React from 'react'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import { Box } from '@mui/material'

interface PublishedStatusIconProps {
  published: boolean
  size?: number
}

/**
 * Shared component for displaying published status as a colored icon.
 * - Green check icon when published
 * - Red X icon when unpublished
 *
 * Used in: ClipList, EpisodesSection, and other content lists
 */
export function PublishedStatusIcon ({ published, size = 20 }: PublishedStatusIconProps) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {published ? (
        <CheckIcon sx={{ color: '#2e7d32', fontSize: size }} />
      ) : (
        <CloseIcon sx={{ color: '#c62828', fontSize: size }} />
      )}
    </Box>
  )
}
